import { Stack } from 'component-library';

import { PlotReportFactElement } from '@/api/rest/resources/types/fact';
import {
  getNCChangeIcon,
  getNCChangeIconVariant,
  NCFactCapsule,
  NCFactCapsuleProps,
} from '@/components/NCFactCapsule/NCFactCapsule';
import { isNullish } from '@/utils/booleans';

export const LEGEND_ITEMS = [
  { value: 0, color: '#ffffff' },
  { value: 0.1, color: '#fffefe' },
  { value: 0.2, color: '#fed8d6' },
  { value: 0.3, color: '#eeb094' },
  { value: 0.4, color: '#d0a35a' },
  { value: 0.5, color: '#9a9132' },
  { value: 0.6, color: '#647e43' },
  { value: 0.7, color: '#396e59' },
  { value: 0.8, color: '#1a5862' },
  { value: 0.9, color: '#103f60' },
  { value: 1, color: '#011959' },
];
const COMPONENT_WIDTH = 250; // in pixels
const ARROW_FONT_SIZE = 20;

export const FactLinearGradient = ({
  latestFact,
  ncFactCapsuleProps,
}: {
  latestFact?: PlotReportFactElement<number> | null;
  ncFactCapsuleProps?: Partial<NCFactCapsuleProps>;
}) => {
  return (
    <Stack spacing={6} className='w-full p-6' data-testid='fact-linear-gradient-container'>
      <NCFactCapsule
        label={ncFactCapsuleProps?.label ?? ''}
        fact={latestFact}
        capsuleIconProps={{
          icon: getNCChangeIcon(latestFact),
          variant: getNCChangeIconVariant(latestFact),
        }}
        {...ncFactCapsuleProps}
      />
      {!isNullish(latestFact?.value) && <LinearGradient arrowValue={latestFact?.value as number} />}
    </Stack>
  );
};

const LinearGradient = ({ arrowValue }: { arrowValue: number }) => {
  const arrowPosition = arrowValue * COMPONENT_WIDTH - ARROW_FONT_SIZE / 2;

  return (
    <Stack className='rounded-2xl bg-white-100' style={{ width: `${COMPONENT_WIDTH}px` }} data-testid='bar-container'>
      <div className='w-full' data-testid='bar-arrow'>
        <i
          className='block ri-arrow-down-fill -mr-[100%] text-primary-100 w-fit h-fit'
          style={{
            marginLeft: `${arrowPosition}px`,
            fontSize: `${ARROW_FONT_SIZE}px`,
          }}
        />
      </div>
      <Stack spacing={2} className='w-full' data-testid='bar-legend'>
        <div
          className='h-3 w-full rounded-2xl border border-divider'
          style={{ background: `linear-gradient(to right, ${LEGEND_ITEMS.map(({ color }) => color).join(', ')})` }}
        />
        <Stack direction='row' className='justify-between w-full'>
          {LEGEND_ITEMS.map(({ value }) => (
            <span key={value} className='typography-caption text-text-secondary'>
              {value}
            </span>
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
};
